export default {
    path: "/exportPage",
    name: "exportPage",
    meta: {
        title: "其他应用引入"
    },
    props: true,
    component: () => import("@/views/exportPage/exportPage.vue"),
    children: [
        {
            path: "/modPreview/:_key",
            name: "modPreview",
            meta: {
                title: "工作表-预览",
                norpermission: true
            },
            props: true,
            component: () => import("@/views/menu/sheet/sheet.vue")
        },
        {
            path: "/dashboardPreview/:companyId/:appId/:_key/:layout",
            name: "dashboardPreview",
            meta: {
                title: "仪表盘-预览",
                norpermission: true
            },
            props: true,
            component: () => import("@/views/menu/dashboard/dashboard.vue")
        },
        {
            path: "/flowInstsShow/:companyId/:appId/:_key",
            name: "flowInstsShow",
            meta: {
                title: "流程-查看数据",
                norpermission: true
            },
            props: true,
            component: () => import("@/views/flow/flowInst/flowInstsShow.vue")
        }
    ]
};



// WEBPACK FOOTER //
// ./src/router/modules/exportPage.js